import React, { useEffect, useState } from "react";
import Illustration from "../../../../partials/content/Illustration";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { getSalesOverviewReport } from "../../../../services/sales/salesReportService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function SalesOverviewReport(props) {
  const { reload } = useGlobalData();
  const [salesOverview, setSalesOverview] = useState([]);

  useEffect(() => {
    getSalesOverviewData();
  }, [reload]);

  const top5ProductCustomersColumn = [
    {
      header: "Customer Group",
      field: "customerGroup",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Customer Name",
      field: "customerName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.customerName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Currency",
      field: "currencyCode",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Quantity",
      field: "qty",
      body: (rowData) => (
        <div>
          {rowData.qty} {rowData.uomName}
        </div>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Unit",
      field: "uomName",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Sales Count",
      field: "salesCount",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Sales Amount",
      field: "salesAmount",
      body: (rowData) => (
        <NumberFormat
          value={rowData.salesAmount}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Average Sales",
      field: "averageSales",
      body: (rowData) => (
        <NumberFormat
          value={rowData.averageSales}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
  ];

  return (
    <React.Fragment>
      {salesOverview.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesOverview}
            dataDetailName="productCustomers"
            dataDetailColumns={top5ProductCustomersColumn}
            dataDetailTitle="Top 5 Product Customers"
            onRefreshData={() => {
              getSalesOverviewData();
            }}
            columns={[
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Item Code",
                field: "itemCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uomName}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uomName",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Sales Count",
                field: "salesCount",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Amount",
                field: "salesAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Average Sales",
                field: "averageSales",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.averageSales}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Cost of Goods Sold",
                field: "cogs",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.cogs}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Net Profit",
                field: "netProfit",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.netProfit}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description="You don't have any Sales Overview data yet"
            guidance="Hint: once the Item is created, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getSalesOverviewData() {
    const response = await getSalesOverviewReport();
    const { data } = response.data;
    setSalesOverview(data.salesOverviewReport);
  }
}

export default SalesOverviewReport;
